import { createFileRoute } from "@tanstack/react-router"
import { Contact, meta } from "@/content"

export const Route = createFileRoute("/(public)/contact")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Contact" }) }),
})

function RouteComponent() {
  return <Contact />
}
